import React, { useState, useEffect } from "react";
import { Box, FormControl, MenuItem, Select, Stack } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import DateRangeSelector from "../../../utility/datePicker";
import { setDates } from "../../../redux/slices/filtersSlice";

const TimePeriodFilter = () => {
  const dispatch = useDispatch();
  const { period: reduxPeriod } = useSelector((state) => state.filters);

  const [period, setPeriod] = useState(reduxPeriod || "lastWeek");
  const [showCustomPicker, setShowCustomPicker] = useState(
    reduxPeriod === "custom",
  );

  useEffect(() => {
    setShowCustomPicker(reduxPeriod === "custom");
    setPeriod(reduxPeriod);
  }, [reduxPeriod]);

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handlePeriodChange = (event) => {
    const selected = event.target.value;
    setPeriod(selected);

    if (selected === "custom") {
      setShowCustomPicker(true);
      return;
    }

    setShowCustomPicker(false);

    const now = new Date();
    let start = null;
    const end = now;

    if (selected === "last24hrs") {
      start = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    } else if (selected === "lastWeek") {
      start = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    } else if (selected === "lastMonth") {
      start = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
    } else if (selected === "lastYear") {
      start = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
    }

    // Dispatching to Redux triggers fetchAllData re-run automatically
    dispatch(
      setDates({
        startDate: formatDate(start),
        endDate: formatDate(end),
        period: selected,
      }),
    );
  };

  const handleCustomApply = (tempStartDate, tempEndDate) => {
    if (!tempStartDate && !tempEndDate) return;
    dispatch(
      setDates({
        startDate: tempStartDate,
        endDate: tempEndDate,
        period: "custom",
      }),
    );
  };

  const menuTextStyle = { fontSize: "14px" };

  return (
    <Box display="flex" alignItems="center" gap={2} sx={{ minWidth: 0 }}>
      <FormControl sx={{ minWidth: 180, flexShrink: 0 }} size="small">
        <Select
          value={period}
          sx={{ borderRadius: "10px", height: "35px", fontSize: "14px" }}
          onChange={handlePeriodChange}
        >
          <MenuItem sx={menuTextStyle} value="last24hrs">
            Last 24 Hours
          </MenuItem>
          <MenuItem sx={menuTextStyle} value="lastWeek">
            Last Week
          </MenuItem>
          <MenuItem sx={menuTextStyle} value="lastMonth">
            Last Month
          </MenuItem>
          <MenuItem sx={menuTextStyle} value="lastYear">
            Last Year
          </MenuItem>
          <MenuItem sx={menuTextStyle} value="custom">
            Custom
          </MenuItem>
        </Select>
      </FormControl>
      <Box sx={{ width: 230, flexShrink: 0 }}>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{ visibility: showCustomPicker ? "visible" : "hidden" }}
        >
          <DateRangeSelector onHandleClick={handleCustomApply} />
        </Stack>
      </Box>
    </Box>
  );
};

export default TimePeriodFilter;
